import { Cache } from "memory-cache";
import { CharacterWalletJournalEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCharacterWalletJournalEntity(id: number): Promise<CharacterWalletJournalEntity | null> {
  let entity: any = await cache.get(id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCharacterWalletJournalEntity(transaction: CharacterWalletJournalEntity) {
  cache.put(transaction.props.id.toString(), transaction, 60 * 60 * 1000 /* 1 hour */);
}
